import ProfitLossChart from "@/components/PagesComponents/ProfitLossChartPage/ProfitLossChart";

export default { ProfitLossChart };
